<template>
  <div class="page-logistics-info">
    <div class="pg-breadcrumb">
      <div class="breadcrumb-item em">查詢快件</div>
      <div class="breadcrumb-item">快遞信息</div>
    </div>

    <div class="pg-block">
      <Spin fix class="pg-sub-loading" v-if="isLoading">
        <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
        <div class="loading-text">Loading</div>
      </Spin>
      <div class="back-home" @click="$router.back()">返回</div>
      <br>
      <div style="font-weight:bold">快遞信息</div>
      <br>
      <Table no-data-text="" :columns="table.column" :data="table.data"></Table>
      <Table no-data-text="" :columns="table.column1" :data="table.data1"></Table>
      <Table no-data-text="" :columns="table.column2" :data="table.data2"></Table>
      <Table no-data-text="" :columns="table.column3" :data="table.data3">
        <template slot-scope="{row,index}" slot="status">
          <span v-if="row.status == 0">珠海倉庫(待出庫)</span>
          <span v-else-if="row.status == 1">珠海倉庫(已出庫)</span>
          <span v-else-if="row.status == 2">澳門倉庫(配送中)</span>
          <span v-else-if="row.status == 3 && addresstype == '門店'">澳門門店-未簽收</span>
          <span v-else-if="row.status == 4 && addresstype == '門店'">澳門門店-已簽收</span>
          <span v-else-if="row.status == 3 && addresstype == '智能櫃'">智能櫃-未簽收</span>
          <span v-else-if="row.status == 4 && addresstype == '智能櫃'">智能櫃-已簽收</span>
        </template>
      </Table>
      <Table no-data-text="" :columns="table.column4" :data="table.data4"></Table>
      <Table no-data-text="" :columns="table.column5" :data="table.data5"></Table>
      <br><br>
      <div style="font-weight:bold">物流信息</div>
      <br>

      <div class="step-wrap" v-if="detail && detail.length">
        <div class="step-item clearfix" v-for="(item, index) in detail" :key="item.id">
          <div class="left">
            <div class="l-date">
              <span>{{ item.date }}</span>
              <span>{{ item.week }}</span>
            </div>
            <div class="l-time">{{ item.time }}</div>
          </div>
          <div class="right">
            <div class="r-address">{{item.describe}}{{ item.userinfos ? (' , 操作人名字：'+item.userinfos) : '' }}</div>

<!--            <div class="r-address">{{ filterRemak(item.describe,item.userinfos) }}</div>-->
          </div>
        </div>
      </div>

      <div class="data-null" v-else>
        <img src="../../assets/images/null-data.png" alt="" draggable="false">
        <div>暫無數據</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pageParam: {},
      isLoading: false,
      detail: [],
      addresstype: '',
      table: {
        column: [
          {
            title: '快遞單號',
            key: 'order',
            align: 'center',
            minWidth: 80
          },
          {
            title: '客戶電話',
            key: 'phone',
            align: 'center',
            minWidth: 80
          },
          {
            title: '客戶名稱',
            key: 'username',
            align: 'center',
            minWidth: 80
          },
        ],
        column1: [
          {
            title: '重量',
            key: 'weight',
            align: 'center',
            minWidth: 100
          },
          {
            title: '尺寸',
            key: 'size_sum',
            align: 'center',
            minWidth: 100
          },
          {
            title: '提貨櫃點',
            key: 'store',
            align: 'center',
            minWidth: 100
          },
        ],
        column2: [
          {
            title: '快件明細',
            key: 'detailed',
            align: 'center',
            minWidth: 100
          },
          {
            title: '異常件',
            key: 'abnormal',
            align: 'center',
            minWidth: 100
          },
          {
            title: '出庫袋號',
            key: 'sack_number',
            align: 'center',
            minWidth: 100
          },
        ],
        column3: [
          {
            title: '最新貨態',
            slot: 'status',
            align: 'center',
            minWidth: 100
          },
          {
            title: '更新時間',
            key: 'updated_time',
            align: 'center',
            minWidth: 100
          },
          {
            title: '貨架號',
            key: 'shelves',
            align: 'center',
            minWidth: 100
          },
        ],
        column4: [
          {
            title: '代收費',
            key: 'amount',
            align: 'center',
            minWidth: 100
          },
          {
            title: '附加費',
            key: 'surcharge_price',
            align: 'center',
            minWidth: 100
          },
          {
            title: '到附運費',
            key: 'freight_collect',
            align: 'center',
            minWidth: 100
          },
        ],
        column5: [
          {
            title: '超期費',
            key: 'outTime_price',
            align: 'center',
            minWidth: 100
          },
          {
            title: '合計費用',
            key: 'total_price',
            align: 'center',
            minWidth: 100
          },
        ],
        data: [],
        data1: [],
        data2: [],
        data3: [],
        data4: [],
        data5: [],
      },
    };
  },
  components: {},
  computed: {},
  created() {
    this.pageParam = this.$route.query;
    console.log(this.pageParam)
    this.getDetail();
    this.getLogistics();
  },
  methods: {
	  filterRemak(remak,userinfos) {
	  	const str1 =  remak?.split('操作人：')

		  console.log(str1)
		  let str2 = ''
		  if (str1.length > 1) {
			  let userinfos2 = ''
			  console.log(userinfos)
			  if (userinfos) {
				  userinfos2 = '操作人：' + userinfos
				  console.log(userinfos2)
				  str2  = str1[0] + userinfos2
			  }else {
				  str2 = remak
			  }
		  }else {
		  	str2 = remak
		  }
		  if (str2.toString().indexOf('操作人：') == -1 && userinfos) {
			  str2 = remak + ' ,操作人：' + userinfos
		  }
	  	return str2.toString()
	  },
    getDetail() {
      this.$Rq.requestAuth({
        url: this.$Api.all_search_detail_new,
        method: 'get',
        data: {
          order_id: this.pageParam.orderid
        }
      }).then((res) => {
        let tempArr = [];
        let tempArr1 = [];
        let tempArr2 = [];
        let tempArr3 = [];
        let tempArr4 = [];
        let tempArr5 = [];
        let resData = res.data;

        if (res.code == 0) {
          for (let i = 0; i < resData.data.length; i++) {
            this.addresstype = resData.data[i].addressType;

            tempArr.push({
              order: resData.data[i].order,
              username: resData.data[i].username,
              phone: resData.data[i].phone,
            });

            tempArr1.push({
              weight: resData.data[i].weight,
              size_sum: resData.data[i].long + 'x' + resData.data[i].width + 'x' + resData.data[i].height,
              store: resData.data[i].store == null ? '- - -' : resData.data[i].store.ReceivingName,
            });

            tempArr2.push({
              sack_number: resData.data[i].sack_number,
              detailed: resData.data[i].detailed == null ? '- - -' : resData.data[i].detailed.name,
              abnormal: resData.data[i].abnormal == 0 ? '否' : '是',
            });

            tempArr3.push({
              shelves: resData.data[i].shelves == null ? '- - -' : resData.data[i].shelves.code,
              status: resData.data[i].status,
	            updated_time: resData.data[i].updated_time,
            });

            tempArr4.push({
              amount: resData.data[i].amount,
              surcharge_price: resData.data[i].surcharge_price,
              freight_collect: resData.data[i].freight_collect,
            });

            if (resData.data[i].status == 4) {
              resData.data[i].outTime_price = 0;
            }

            tempArr5.push({
              outTime_price: resData.data[i].outTime_price,
              total_price: Number(resData.data[i].surcharge_price) + Number(resData.data[i].outTime_price) + Number(resData.data[i].freight_collect) + Number(resData.data[i].amount),
            });
          }
          this.table.data = tempArr;
          this.table.data1 = tempArr1;
          this.table.data2 = tempArr2;
          this.table.data3 = tempArr3;
          this.table.data4 = tempArr4;
          this.table.data5 = tempArr5;
        }
      });
    },
    getLogistics() {
      this.isLoading = true;
      this.$Rq.requestAuth({
        url: this.$Api.logisticsInfo + '/' + this.pageParam.order,
        method: 'get',
        data: {}
      }).then((res) => {
        this.isLoading = false;
        if (res.code == 0) {
          let resData = res.data;
          let tempArr = [];
          let userinfo;

          for (let i = 0; i < resData.length; i++) {
            let datetime = this.getDateTime(resData[i].created_at);

            if (resData[i].userinfos == null) {
              if (resData[i].remarks.match(/[\u606d\u559c\u60a8]/g)) {
                userinfo = '用戶線上支付';
              } else {
                if (resData[i].admin_name != null) {
                  userinfo = resData[i].admin_name;
                } else {
                  userinfo = '智能櫃派送員';
                }
              }
            } else {
              userinfo = resData[i].userinfos.username;
            }
	          const temp = resData[i]?.userinfos?.realname || ''
            tempArr.push({
              userinfos: temp,
              id: resData[i].id,
              date: datetime.date,
              week: datetime.week,
              time: datetime.time,
              describe: resData[i].remarks
            });
          }

          this.detail = tempArr;
        }
      }).catch((err) => {
        this.isLoading = false;
      });
    },
    getDateTime(datetime) {
      let date = new Date(datetime);
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate();
      let hour = date.getHours();
      let minute = date.getMinutes();
      let second = date.getSeconds();
      let week = date.getDay();
      let weekList = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];

      return {
        date: `${this.formateNum(year)}-${this.formateNum(month)}-${this.formateNum(day)}`,
        time: `${this.formateNum(hour)}:${this.formateNum(minute)}:${this.formateNum(second)}`,
        week: weekList[week]
      };
    },

    formateNum(num) {
      return num > 9 ? num : '0' + num;
    }
  }
}
</script>

<style lang="scss" scoped>
@import "homeDetail.scss";
</style>
